const _ = "adyen-pe-card", t = `${_}__body`, o = `${_}__header`, n = `${_}__title`, D = `${_}__subtitle`, A = `${o}-content`, R = `${t}--with-title`, c = `${_}--no-outline`, C = `${_}--no-padding`, e = `${_}--filled`, s = `${_}__footer`;
export {
  _ as CARD_BASE_CLASS,
  t as CARD_BODY,
  R as CARD_BODY_WITH_TITLE,
  e as CARD_FILLED,
  s as CARD_FOOTER,
  o as CARD_HEADER,
  A as CARD_HEADER_CONTENT,
  c as CARD_NO_OUTLINE,
  C as CARD_NO_PADDING,
  D as CARD_SUBTITLE,
  n as CARD_TITLE
};
